// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
import { generateKeyStr } from '../../../infrastructure/utils/common';
import '../../../styles/components/PartiesList.css';

export default class EntertainmentsList extends React.PureComponent {
  deleteEntertainment = ({ currentTarget }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { deleteEntertainment } = this.props;
    deleteEntertainment(
      currentTarget.getAttribute('data-ent'),
      'entertainments'
    );
  };

  updateEntertainment = ({ currentTarget }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { updateEntertainment } = this.props;
    updateEntertainment(
      currentTarget.getAttribute('data-ent'),
      'entertainments'
    );
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { content } = this.props;
    return (
      <div className='partieslist'>
        <Table hover>
          <thead>
            <tr>
              <th>Icon</th>
              <th>Title</th>
              <th style={{ textAlign: 'center' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {content.map(elem => (
              <tr key={elem.id}>
                <td style={{ width: '5%' }}>
                  <img
                    src={
                      elem.picture.blob
                        ? elem.picture.data
                        : `${elem.picture.data}?p=${generateKeyStr()}`
                    }
                    style={{ width: '40px', height: '40px' }}
                    alt='...'
                    className='img-thumbnail'
                  />
                </td>
                <td style={{ verticalAlign: 'middle' }}>{elem.title}</td>
                <td
                  style={{
                    width: '5%',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                    cursor: 'pointer',
                  }}
                >
                  <i
                    className='fas fa-pen'
                    data-ent={elem.id}
                    onClick={this.updateEntertainment}
                    style={{ marginRight: '10px' }}
                  />
                  <i
                    className='fas fa-times'
                    data-ent={elem.id}
                    onClick={this.deleteEntertainment}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}
